import React, { useContext } from 'react'
import { GetProviderResponse } from './Response'
import { iPapiClient, IP_API_KEY } from './ApiClient'

const additionalParams = {
  apiKey: '?key=' + IP_API_KEY,
  fields: 'fields=regionName,city,isp,mobile',
}

export interface ApiInterface {
  getProviderResponse: (ipAdress: string) => Promise<GetProviderResponse | null>
}

const Api: ApiInterface = {
  getProviderResponse: async (
    ipAddress: string
  ): Promise<GetProviderResponse | null> => {
    try {
      const response = await iPapiClient().get(
        ipAddress + additionalParams.apiKey + '&' + additionalParams.fields
      )
      return response.data
    } catch (err) {
      console.log(err)
      return null
    }
  },
}

export const Context = React.createContext<ApiInterface>(Api)

const useIPApi = () => useContext(Context)

export default useIPApi
